<div class="container my-5">
  <div class="container  text-center " style="width: 75%">
    <h3  class="display-5 fw-light" style="color: var(--secondary-color);">¿Cuándo es <span class="fw-bold">importante?</span></h3>
  </div>
</div>




<div class="d-flex flex-column flex-md-row p-2 gap-4 align-items-center justify-content-center">

  <div class="list-group w-50" >
    <a *ngFor="let item of items" class=" mx-auto d-flex align-items-center gap-3 py-3" aria-current="true">
      <img src="{{ item.icon }}" alt="" width="40"
           height="40" class=" ">
      <div class="d-flex gap-2 w-100 justify-content-between">
        <div>
          <p class="mb-0 text-secondary"><span class="fw-bold">{{ item.name }}: </span>{{ item.description }}</p>
        </div>
      </div>
    </a>

  </div>
</div>
